import { commonPayAccountRules } from './commonPayAccountRules';

// eslint-disable-next-line import/prefer-default-export
export const getPayAccountInvoicingValidator = () => ({
  ...commonPayAccountRules,
});
